/*
	usage:
	array-argument:
	window.CORE.nodetree.fragment([nodeA,nodeB,...,nodeN])

	or
	window.CORE.nodetree.fragment(nodeA]);

	or
	window.CORE.nodetree.fragment();

	return:
	a document-fragment
*/
const isArray = function (o) {
          return Object.prototype.toString.call(o) === '[object Array]';
      };

const createTree = function (nodes) {
    const docf = document.createDocumentFragment();
    try {
        if (nodes && isArray(nodes)) {
            nodes.forEach(elm => {
                docf.appendChild(elm);
            });
        } else if (nodes) {
            docf.appendChild(nodes);
        }
    } catch (e) {
        console.error(e);
    }
    return docf;
};

/*api*/
export default {
	fragment(nodes) {
		if (arguments.length > 1) {
			console.warn('nodetree: arguments must be sent as an array or only the first argument will be used');
		}
		return createTree(nodes);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/nodetree.js